import avrProducts from '@/utils/enums/avrProducts';

export default store => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'vehicle/SET_VEHICLE_INFO' && !!mutation.payload) {
      // Spotlight is enabled?
      const hasSpotlight = state.business.info.products.includes(avrProducts.SPOTLIGHT);
      if (hasSpotlight) {
        // When VIN is decoded, Call spotlight endpoint
        const { language, condition, mileage, purchasePrice } = state.route.query;
        const { vin, make } = mutation.payload;

        store.commit('SET_LOADING', true);
        store
          .dispatch('spotlight/fetchSpotlights', {
            language,
            vin,
            condition,
            make,
            mileage,
            price: purchasePrice,
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
          })
          .finally(() => {
            store.commit('SET_LOADING', false);
          });
      }
    }
  });
};
